<svelte:options tag={null}/>

<script>
    import { getDateRows, uuid, noop } from "./date-time.js";
    import { createEventDispatcher } from "svelte";
    import { get_current_component } from "svelte/internal";
    import eventDispatcher from '../../EventDispatcher';

    const component = get_current_component();
    const dispatch = createEventDispatcher();
    
  
    // props
    export let date = new Date();
    export let month;
    export let year;
    export let isAllowed = () => true;
    export let hideWeeklyView=false;
  
    // local vars to help in render
    const weekdays = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
    let cells;
  
    // function helpers
    const onChange = date => {
      let data = new Date(year, month, date);
      dispatch("datechange", new Date(year, month, date));
      eventDispatcher.dispatchCustomEvent(component, new Event('datechange'), 'datechange', data);
    };
  
    const allow = (year, month, date) => {
      if (!date) return true;
      return isAllowed(new Date(year, month, date));
    };
  
    $: cells = getDateRows(month, year).map(c => ({
      value: c,
      allowed: allow(year, month, c)
    }));
  </script>
  
  <style type="text/scss" lang="scss">
    @import '../../global.scss';
    .container {
      padding: 2px;
      min-width: 250px;
      min-height: 190px;
      font-family: "Poppins", sans-serif;
      color: $and-charcoal;
      @include fontSize(16px);
    }
    
    .row {
      display: flex;
      margin: 0 6px;
      padding: 0 8px;
      flex-wrap: wrap;
      justify-content: space-around;
    }
    .hideVisibility{
      display: none;
    }
  
    .cell {
      display: inline-block;
      width: 20px;
      height: 25px;
      text-align: center;
      padding: 2px 4px;
      margin: 1px;
    }

    .cell-title {
      font-weight: 800;
    }
  
    .selected {
      background: $and-blue;
      border-radius:20px;
      color: white;
    }
  
    .disabled {
      background: #efefef;
      cursor: not-allowed;
      color: #bfbfbf;
    }
  
    .highlight:hover {
      border: 1px solid $and-blue;
      border-radius:20px;
      cursor: pointer;
      padding: 1px 3px;
    }
  
    .selected.highlight:hover {
      background: $and-blue;
    }
  </style>
  
  <div class="container" >
    <div class="row" class:hideVisibility={hideWeeklyView}>
      {#each weekdays as day}
        <div class="cell cell-title">{day}</div>
      {/each}
    </div>
  
    <div class="row" class:hideVisibility={hideWeeklyView}>
      {#each cells as { allowed, value } (uuid())}
        <div
          on:click={allowed && value ? onChange.bind(this, value) : noop}
          class="cell"
          class:highlight={allowed && value}
          class:disabled={!allowed}
          class:selected={new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() === new Date(year, month, value).getTime()}>
          {value || ''}
        </div>
      {/each}
    </div>
  </div>
  